module.exports = __webpack_public_path__ + "img/backgroundFourth.758e3010.png";